module.exports = __webpack_public_path__ + "img/newExp.6464842f.png";